/**
 * @file 联系方式组件
 * @author hukeke01
 */
import React from 'react';
import copy from 'copy-to-clipboard';
import {message, Popover, Tooltip} from 'antd';

import IconCopy from './imgs/icon-copy.svg';
import IconQrcode from './imgs/icon-qrcode.svg';

import './style.less';
interface IContactItemProps {
    contactIcon?: string;
    contactName: string;
    contactSubtext?: string;
    copyText?: string;
    picQrCode?: string;
    nameColor?: string;
    nameClickCallback?: () => void;
    copyCallback?: () => void;
}
export default function ContactItem(props: IContactItemProps) {
    const {
        contactIcon, contactName, copyCallback,
        contactSubtext, copyText, picQrCode,
        nameColor, nameClickCallback
    } = props;
    const onCopy = () => {
        copy(copyText || '');
        message.success({
            content: '内容已复制',
            delay: 3000
        });
        copyCallback && copyCallback();
    };
    const onItemClick = () => {
        nameClickCallback && nameClickCallback();
    };

    return (<div className="contact-item">
        <div className="contact-left">
            {contactIcon && <img className="contact-icon" src={contactIcon} />}
            <Tooltip title={contactName}>
                <div
                    className={'contact-label' + (nameColor ? ' ' + nameColor : '')}
                    onClick={onItemClick}
                >
                    {contactName}
                </div>
            </Tooltip>
        </div>
        <div className="contact-right">
            {contactSubtext && <Tooltip title={contactSubtext}>
                <div className="contact-text">{contactSubtext}</div>
            </Tooltip>}
            <div className="icon-group">
                {copyText && <div className="option-wrap" onClick={onCopy}>
                    <img src={IconCopy} />
                </div>}
                {picQrCode && <div>
                    <Popover
                        content={<div className="qrcode-wrap">
                            <img className="contact-qrcode" src={picQrCode} />
                        </div>}
                        trigger="hover"
                        placement="bottom"
                        overlayClassName={'comp-contact-item-popover'}
                    >
                        <div className="option-wrap">
                            <img src={IconQrcode} className="icon-scan"></img>
                        </div>
                    </Popover>
                </div>}
            </div>
        </div>
    </div>);
}